import React from 'react';
import MyBriefsListItem from './MyBriefsListItem';
import MyBriefsEmptyState from './MyBriefsEmptyState';
import { formatDraftDayDividerLabel, getDraftDayGroupKey } from './myBriefsUtils';

function MyBriefsList({
  items,
  nowMs,
  currentUserEmail,
  showOwnerMeta,
  forceReadOnlyOwnerView,
  expandedIds,
  onToggleExpanded,
  detailById,
  detailLoadingById,
  editDraftById,
  comparisonViewById,
  dirtyById,
  savingById,
  saveStatusById,
  onComparisonViewChange,
  onEditFieldChange,
  onSave,
  onCopy,
  onPublishCms,
  onSendToClient,
  onRegenerate,
  onRetry,
  onDelete,
  onRestore,
  onPermanentDelete,
  onOpenTranslate,
  translatingById,
  sentinelRef,
  loadingMore,
  hasMore,
}) {
  if (!items.length) {
    return <MyBriefsEmptyState />;
  }

  let previousDayKey = '';

  return (
    <div className="my-briefs-list-wrap">
      {items.map((item) => {
        const dayKey = getDraftDayGroupKey(item.createdAt);
        const showDayDivider = dayKey && dayKey !== previousDayKey;
        const dividerLabel = showDayDivider ? formatDraftDayDividerLabel(item.createdAt, nowMs) : '';
        const canManage = !forceReadOnlyOwnerView && (!showOwnerMeta || !currentUserEmail || !item.userEmail || item.userEmail === currentUserEmail);
        if (dayKey) {
          previousDayKey = dayKey;
        }
        return (
          <React.Fragment key={item._id}>
            {showDayDivider ? (
              <div
                className={`my-briefs-day-divider${dividerLabel === 'Today' ? ' is-today' : ''}`}
                data-testid={`my-briefs-day-divider-${dayKey}`}
              >
                <span className="my-briefs-day-divider-label">{dividerLabel}</span>
              </div>
            ) : null}
            <MyBriefsListItem
              item={item}
              nowMs={nowMs}
              showOwnerMeta={showOwnerMeta}
              canManage={canManage}
              isExpanded={expandedIds.has(item._id)}
              onToggle={onToggleExpanded}
              detail={detailById[item._id]}
              detailLoading={Boolean(detailLoadingById[item._id])}
              editDraft={editDraftById[item._id]}
              comparisonView={comparisonViewById[item._id]}
              isDirty={Boolean(dirtyById[item._id])}
              isSaving={Boolean(savingById[item._id])}
              saveStatus={saveStatusById?.[item._id] || null}
              onComparisonViewChange={(nextVariant) => onComparisonViewChange(item._id, nextVariant)}
              onEditFieldChange={(field, value) => onEditFieldChange(item._id, field, value)}
              onSave={() => onSave(item._id)}
              onCopy={() => onCopy(item._id)}
              onPublishCms={onPublishCms ? () => onPublishCms(item._id) : null}
              onSendToClient={onSendToClient ? () => onSendToClient(item._id) : null}
              onRegenerate={() => onRegenerate(item._id)}
              onRetry={() => onRetry(item._id)}
              onDelete={() => onDelete(item._id)}
              onRestore={() => onRestore(item._id)}
              onPermanentDelete={() => onPermanentDelete(item._id)}
              onOpenTranslate={onOpenTranslate ? () => onOpenTranslate(item._id) : null}
              isTranslating={Boolean(translatingById?.[item._id])}
            />
          </React.Fragment>
        );
      })}

      {hasMore ? <div ref={sentinelRef} className="my-briefs-list-sentinel" /> : null}

      {loadingMore ? (
        <div className="my-briefs-loading-more">
          <span className="my-briefs-spinner" aria-hidden="true" />
          <span>Loading more briefs</span>
        </div>
      ) : null}
    </div>
  );
}

export default MyBriefsList;
